import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as filesDemo from '../files-demo'

export const RESOURCE = {
  payload: {
    modelId: filesDemo.MODEL_ID,
    values: {
      [PartialId.Standard.create('active_periods')]: '{(,)}',
      [PartialId.Standard.create('code')]: 'sample_2',
      [PartialId.Standard.create('documents')]: ['sample-file-b.docx'],
      [PartialId.Standard.create('id')]: 'files_demo_sample_2',
      [PartialId.Standard.create('label')]: 'Sample Document B',
      [PartialId.Standard.create('name')]: 'Sample Document B',
    },
  },
  type: core.quiver.Resource.Type.DmsRecord,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsRecord>
